import { useState, useEffect, useCallback, useRef } from 'react';
import styles from './SuggestedActivities.module.css';
import { useTripInfo } from "../context";
import { useNavigate } from "react-router-dom";
import { API_URL } from '../utils/fatch';
import { Link } from 'react-router-dom';
import { NoWeather } from '../weather/noWeather';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';
import { AttractionCardSkeleton, gridStyles } from './Skeleton.jsx';
import { Suggested_header } from './header.jsx';
import { useItinerary, Itinerary, ItineraryButton } from './Itinerary';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

const mapContainerStyle = {
    width: '100%',
    height: '100%',
};

const mapOptions = {
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: true,
};



// --- Mock Data ---
// ... (mainCategories and activities arrays remain the same) ...





const filters = [
    {
        id: 1,
        // Nightlife: reuse the Nightlife icon from `filters` (distinct)
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M200-160v-80h80v-160L40-760h560L360-400v160h80v80H200Zm36-440h168l56-80H180l56 80Zm404 440q-50 0-85-35t-35-85q0-50 35-85t85-35q11 0 21 1.5t19 6.5v-368h200v120H760v360q0 50-35 85t-85 35Z" /></svg>,
        label: "Nightlife"
    },
    {
        id: 2,
        // Adventure: reuse the main 'Activities' icon so it's clearly different
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="m233-80 54-122q-14-11-27-21.5T235-246q-8 3-15.5 4.5T203-240q-33 0-56.5-23.5T123-320q0-20 8.5-36.5T155-384q-8-23-11-46.5t-3-49.5q0-26 3-49.5t11-46.5q-15-11-23.5-27.5T123-640q0-33 23.5-56.5T203-720q9 0 16.5 1.5T235-714q33-36 75.5-60t90.5-36q5-30 27.5-50t52.5-20q30 0 52.5 20.5T561-810q48 12 90.5 35.5T727-716q8-3 15-4.5t15-1.5q33 0 56.5 23.5T837-642q0 20-8 35.5T807-580q8 24 11 49t3 51q0 26-3 50.5T807-382q14 11 22 26.5t8 35.5q0 33-23.5 56.5T757-240q-8 0-15-1.5t-15-4.5q-12 12-24.5 23.5T675-200l52 120h-74l-38-88q-14 6-27 10.5t-27 7.5q-5 29-27.5 49.5T481-80q-30 0-52.5-20T401-150q-15-3-28.5-7.5T345-168l-38 88h-74Zm76-174 62-140q-14-18-22-40t-8-46q0-57 41.5-98.5T481-620q57 0 98.5 41.5T621-480q0 24-8.5 47T589-392l62 138q9-8 17.5-14.5T685-284q-5-8-6.5-17.5T677-320q0-32 22-55t54-25q6-20 9-39.5t3-40.5q0-21-3-41.5t-9-40.5q-32-2-54-25t-22-55q0-9 2.5-17.5T685-676q-29-29-64-49t-74-31q-11 17-28 26.5t-38 9.5q-21 0-38-9.5T415-756q-41 11-76 31.5T275-674q3 8 5.5 16.5T283-640q0 32-21 54.5T209-560q-6 20-9 39.5t-3 40.5q0 21 3 40.5t9 39.5q32 2 53 25t21 55q0 9-1.5 17.5T275-286q8 9 16.5 16.5T309-254Zm60 34q11 5 22.5 9t23.5 7q11-17 28-26.5t38-9.5q21 0 38 9.5t28 26.5q12-3 22.5-7t21.5-9l-58-130q-12 5-25 7.5t-27 2.5q-15 0-28.5-3t-25.5-9l-58 132Zm112-200q24 0 42-17t18-43q0-24-18-42t-42-18q-26 0-43 18t-17 42q0 26 17 43t43 17Zm0-60Z" /></svg>,
        label: "Adventure"
    },
    {
        id: 3,
        // Family: zoo/children (paw icon)
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="16px" fill="#000000"><path d="M12 13c-2.76 0-5 2.24-5 5 0 .55.45 1 1 1h8c.55 0 1-.45 1-1 0-2.76-2.24-5-5-5zm3.5-8.5c-.83 0-1.5.67-1.5 1.5S14.67 7.5 15.5 7.5 17 6.83 17 6 16.33 4.5 15.5 4.5zM8.5 4.5C7.67 4.5 7 5.17 7 6s.67 1.5 1.5 1.5S10 6.83 10 6 9.33 4.5 8.5 4.5zM5 8c-.83 0-1.5.67-1.5 1.5S4.17 11 5 11s1.5-.67 1.5-1.5S5.83 8 5 8z" /></svg>,
        label: "Family"
    },

    {
        id: 4,
        // Culture: use the 'Tours' icon (distinct from Museum)
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M200-80v-800h80v80h560l-80 200 80 200H280v320h-80Zm80-640v240-240Zm220 200q33 0 56.5-23.5T580-600q0-33-23.5-56.5T500-680q-33 0-56.5 23.5T420-600q0 33 23.5 56.5T500-520Zm-220 40h442l-48-120 48-120H280v240Z" /></svg>,
        label: "Culture"
    },
    {
        id: 5,
        // Outdoor: reuse the Outdoor icon from `filters`
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="m280-40 123-622q6-29 27-43.5t44-14.5q23 0 42.5 10t31.5 30l40 64q18 29 46.5 52.5T700-529v-71h60v560h-60v-406q-48-11-89-35t-71-59l-24 120 84 80v300h-80v-240l-84-80-72 320h-84Zm17-395-85-16q-16-3-25-16.5t-6-30.5l30-157q6-32 34-50.5t60-12.5l46 9-54 274Zm243-305q-33 0-56.5-23.5T460-820q0-33 23.5-56.5T540-900q33 0 56.5 23.5T620-820q0 33-23.5 56.5T540-740Z" /></svg>,
        label: "Outdoor"
    },
    {
        id: 6,
        // Museum: reuse the Museums icon from `filters`
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M80-80v-80h80v-360H80v-80l400-280 400 280v80h-80v360h80v80H80Zm160-80h480-480Zm80-80h80v-160l80 120 80-120v160h80v-280h-80l-80 120-80-120h-80v280Zm400 80v-454L480-782 240-614v454h480Z" /></svg>,
        label: "Museum"
    }
];




export const SuggestedActivities = ({ isDarkMode = false }) => {

    // NEW: State to toggle the filter sidebar
    const [showFilters, setShowFilters] = useState(false);
    const [activeFilters, setActiveFilters] = useState(null);
    const [sortBy, setSortBy] = useState(1);
    const [showMapView, setShowMapView] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // Itinerary hook
    const { itinerary, addToItinerary, removeFromItinerary, clearItinerary, isInItinerary } = useItinerary();
    const [showItinerary, setShowItinerary] = useState(false);

    // Search state (frontend-first implementation)



    const navigate = useNavigate();
    const { currentTripId, loadingUserInfo } = useTripInfo();
    // Seed suggestions with temporary mock data so search/testing works without backend
    const [suggestions, setSuggestions] = useState([]);

    // Derived sorted suggestions for rendering (client-side sorting)
    const [sortedSuggestions, setSortedSuggestions] = useState([]);

  

    /** Sort helper — maps sortById to comparator */
  const sortSuggestions = (list, sortById) => {
    // Create a shallow copy to avoid mutating the original suggestions state
    const items = [...list];

   
    //1 = recommended, 2 = popularity, 3 = rating, 4 = A to Z, 5 = Z to A
 if (sortById === 1) {
        // Recommended: Highest (rating * ratingCount) first
        return items.sort((a, b) => {
            const scoreA = (a.rating || 0) * (a.ratingCount || 1);
            const scoreB = (b.rating || 0) * (b.ratingCount || 1);
            return scoreB - scoreA;
        });

        
    } 

   else if (sortById === 2) {
        // Popularity: Highest ratingCount (or user_ratings_total) first
        return items.sort((a, b) => {
            const countA = a.ratingCount || 0;
            const countB = b.ratingCount || 0;
            return countB - countA;
        });
    } 
    
    else if (sortById === 3) {
        // Rating: Highest rating first
        return items.sort((a, b) => {
            const ratingA = a.rating ||  0;
            const ratingB = b.rating || 0;
            return ratingB - ratingA;
        });
    } 
    
    else if (sortById === 4) {
        // A to Z: Alphabetical by name
        return items.sort((a, b) => {
            const nameA = a.name || "";
            const nameB = b.name || "";
            return nameA.localeCompare(nameB);
        });
    } 
    
    else if (sortById === 5) {
        // Z to A: Reverse Alphabetical
        return items.sort((a, b) => {
            const nameA = a.name || "";
            const nameB = b.name || "";
            return nameB.localeCompare(nameA);
        });
    }

    // Default: Return the list as is (Recommended / API order)
    return items;
};

useEffect(() => {
    setSortedSuggestions(sortSuggestions(suggestions, sortBy));
}, [suggestions, sortBy]);

    const [loading, setLoading] = useState(true);
    const [loadMoreActive, setLoadMoreActive] = useState(false);
    const [nextPageToken, setNextPageToken] = useState({ type: "nearbysearch", value: null });
    const [error, setError] = useState({ status: false, message: '' });
    const [update_trip_needed, setUpdate_trip_needed] = useState(false);

    // Map state
    const [mapInstance, setMapInstance] = useState(null);
    const [hoveredActivityId, setHoveredActivityId] = useState(null);

    // Load Google Maps API
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    });




    const getSuggestions = async () => {

        try {
            setLoading(true);

            const CACHE_TTL = 1000 * 60 * 10; // 10 minutes

            const cached = JSON.parse(localStorage.getItem(`suggestionsCache${currentTripId}`) || "{}");


            if (cached.data) {
                if (Date.now() - cached.timestamp < CACHE_TTL) {
                    setSuggestions(cached.data);
                    setNextPageToken({ type: "nearbysearch", value: cached.token || null });
                    console.log('Using cached suggestions');
                    return;
                } else {
                    localStorage.removeItem(`suggestionsCache${currentTripId}`);
                }

            }



            

            console.log('Fetching new suggestions');

            /*    const response = await fetch(`${API_URL}/suggestions?BudgetBased=${basedOnBudget}`, { */
            const response = await fetch(`${API_URL}/suggestions/all`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 206) {
                setUpdate_trip_needed(true);
                return
            }

            if (!response.ok) {
                console.warn('Error fetching suggestions');
                return

            }

            const data = await response.json();
            console.log('Suggestions fetched:', data);

            if (!data.suggestions || data.suggestions.length === 0) {
                console.log('1')
                setError({ status: true, message: data.message || 'Request failed. Please try again or contact support if the issue continues.' });
                setLoading(false);
                return;
            }
            else {

                console.log(data)
                // setSuggestions(data.suggestions.suggestions); 
                localStorage.setItem(`suggestionsCache${currentTripId}`, JSON.stringify({
                    data: data.suggestions.attractions,
                    timestamp: Date.now(),
                    token: data.suggestions.next_page_token,

                }));


                setSuggestions(data.suggestions.attractions);
                setNextPageToken({ type: "nearbysearch", value: data.suggestions.next_page_token || null });
            }





        } catch (error) {
            console.error('Error fetching suggestions:', error.message);
        } finally {
            setLoading(false);

        }


    };

    useEffect(() => {



        if (loadingUserInfo) return;
        if (currentTripId) {

            getSuggestions();
        } else {
            navigate('/all_trips');

        }



    }, []);



    const getMore = async () => {
        try {
            if (!nextPageToken.value) return;
            console.log('Load more activities clicked');
            setLoadMoreActive(true);

            const response = await fetch(`${API_URL}/suggestions/generateMore?type=${nextPageToken.type}&pagetoken=${encodeURIComponent(nextPageToken.value)}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                console.warn('Error fetching more suggestions', response);
                return;
            }
            const data = await response.json();
            console.log('More suggestions fetched:', data);
            setNextPageToken({ type: data.type, value: data.next_page_token || null });
            setSuggestions((prev) => [...prev, ...data.attractions]);

            // 1. Update UI State
            setNextPageToken({ type: data.type, value: data.next_page_token || null });
            setSuggestions((prev) => [...prev, ...data.attractions]);

            // 2. Cache Logic
            const cacheKey = `suggestionsCache${currentTripId}`;
            const existingCache = JSON.parse(localStorage.getItem(cacheKey) || "{}");

            // ALWAYS merge and deduplicate the data
            const merged = [...(existingCache.data || []), ...data.attractions];
            const deduped = [...new Map(merged.map(item => [item.place_id, item])).values()];

            /**
             * 3. Conditional Metadata Update
             * Define "Plain" as: No active filters (and ideally no search query)
             */
            const isPlainMode = !activeFilters && (!searchQuery || searchQuery.trim() === '');

            const updatedCache = {
                data: deduped, // Data is always updated
                timestamp: isPlainMode ? Date.now() : (existingCache.timestamp || Date.now()),
                token: isPlainMode ? data.next_page_token : (existingCache.token || null)
            };

            localStorage.setItem(cacheKey, JSON.stringify(updatedCache));



        } catch (error) {
            console.error('Error loading more activities:', error.message);
        } finally {
            setLoadMoreActive(false);
        }

    }


    const getThemeClass = () => (isDarkMode ? styles.dark : styles.light);



    // Calculate map center from activities
    const getMapCenter = useCallback(() => {
        const activitiesWithLocation = sortedSuggestions?.filter(activity =>
            activity.location?.lat && activity.location?.lng
        ) || [];

        if (activitiesWithLocation.length === 0) {
            return { lat: 0, lng: 0 };
        }

        const avgLat = activitiesWithLocation.reduce((sum, activity) => sum + activity.location.lat, 0) / activitiesWithLocation.length;
        const avgLng = activitiesWithLocation.reduce((sum, activity) => sum + activity.location.lng, 0) / activitiesWithLocation.length;

        return { lat: avgLat, lng: avgLng };
    }, [sortedSuggestions]);

    // Store map instance when loaded
    const onMapLoad = useCallback((map) => {
        setMapInstance(map);
    }, []);

    // Handle hover on activity list item - pan map to marker
    const handleActivityHover = useCallback((activityId, activity) => {
        setHoveredActivityId(activityId);

        // Pan map to the hovered activity
        if (mapInstance && activity?.location) {
            mapInstance.panTo({
                lat: activity.location.lat,
                lng: activity.location.lng
            });
        }
    }, [mapInstance]);

    const handleActivityHoverEnd = useCallback(() => {
        setHoveredActivityId(null);
    }, []);

    const searchFilters = async () => {


        // getSuggestions

        try {
            setLoading(true);




            console.warn('Fetching filtered suggestions', activeFilters);

            const response = await fetch(`${API_URL}/suggestions/filter?filters=${activeFilters}`, {
                /*  const response = await fetch(`${API_URL}/suggestions/filter?filters=${activeFilters.join(',')}`, { */
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 206) {
                setUpdate_trip_needed(true);
                return

            }

            if (!response.ok) {
                console.warn('Error fetching suggestions');
                return

            }

            const data = await response.json();
            console.log('Suggestions fetched:', data);

            if (!data.suggestions || data.suggestions.length === 0) {

                setError({ status: true, message: data.message || 'Request failed. Please try again or contact support if the issue continues.' });
                setLoading(false);
                return;
            }
            else {

                console.log(data)
                const cacheKey = `suggestionsCache${currentTripId}`;


                const existing = JSON.parse(localStorage.getItem(cacheKey) || "{}");

                //  Build the updated object
                const updated = {
                    ...existing,
                    data: Array.from(
                        new Map(
                            [...suggestions, ...data.suggestions.attractions]
                                .map(item => [item.place_id, item])
                        ).values()
                    )
                };

                //  Save it back
                localStorage.setItem(cacheKey, JSON.stringify(updated));


                setSuggestions(data.suggestions.attractions);
                setNextPageToken({ type: "nearbysearch", value: data.suggestions.next_page_token || null });

            }





        } catch (error) {
            console.error('Error fetching filtered suggestions:', error.message);
        } finally {
            setLoading(false);

        }
    }
    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        setError({ status: false, message: '' });
        if (!activeFilters) {
            getSuggestions();
        } else {
            // Fetch suggestions based on active filters
            searchFilters();
        }
    }, [activeFilters]);






    return (

        <div className={`${styles.root} ${getThemeClass()}`}>



            <main className={styles.mainContent} style={update_trip_needed ? { backgroundColor: 'white' } : {}}>


                {update_trip_needed ?
                    <NoWeather type='noLocationToExplore' />
                    :


                    <>
                        <Suggested_header setSortBy={setSortBy} sortBy={sortBy} showFilters={showFilters} setShowFilters={setShowFilters}
                            activeFilters={activeFilters} getSuggestions={getSuggestions} setSuggestions={setSuggestions} setNextPageToken={setNextPageToken} suggestions={suggestions}
                          searchQuery={searchQuery} setSearchQuery={setSearchQuery}
                        />

                        {/* 4. Main Layout Container (Sidebar + Grid) */}
                        <div className={styles.mainLayoutContainer}>

                            {/* Filter Sidebar */}
                            <aside className={`${styles.filterSidebar} ${!showFilters ? styles.sidebarHidden : ''}`}>
                                <div className={styles.sidebarContent}>
                                    <div className={styles.sidebarHeader}>

                                        <div className={styles.sidebarTitleGroup}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-308 198-252H282l198 252Zm0 0Z" /></svg>
                                            <div>
                                                <h3 className={styles.sidebarTitle}>Filters</h3>
                                                <p className={styles.sidebarSubtitle}>Refine your search</p>
                                            </div>
                                        </div>
                                        <div className={styles.closeSidbar} onClick={() => setShowFilters(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                                        </div>
                                    </div>

                                    <div className={styles.filterOptions}>




                                        {filters.map((filter) => (
                                            <button key={filter.id}
                                                /*  className={`${styles.filterOption} ${activeFilters.includes(filter.id) ? styles.filterOptionActive : ''}`} */
                                                className={`${styles.filterOption} ${activeFilters === filter.id ? styles.filterOptionActive : ''}`}
                                                /*  onClick={() => setActiveFilters(prev => prev.includes(filter.id) ? prev.filter(id => id !== filter.id) : [...prev, filter.id])} */
                                                onClick={() => setActiveFilters(prev => prev === filter.id ? null : filter.id)}
                                            >
                                                {filter.icon}

                                                <span>{filter.label}</span>
                                            </button >

                                        ))}


                                    </div>
                                </div>
                            </aside>

                            {/* Content Section */}
                            {loading ?
                                /*  <div className={styles.loadingIndicator}><GridLoader color="#d4ebfb" size={25} /></div> */
                                <div style={gridStyles}>
                                    {Array(6).fill(0).map((_, i) => <AttractionCardSkeleton key={i} />)}
                                </div>
                                :
                                !error.status ?

                                    <section className={styles.contentSection}>
                                        <div className={styles.resultsHeader}>
                                            {/* <p className={styles.resultsCount}>Showing 8 activities in Paris</p> */}
                                            <div className={styles.viewOptions}>
                                                <button
                                                    className={styles.viewOptionBtn}
                                                    onClick={() => setShowMapView(true)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="m600-120-240-84-186 72q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v560q0 13-7.5 23T812-192l-212 72Zm-40-98v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z" /></svg>
                                                    <span className={styles.viewOptionText}>Map View</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className={styles.activityGrid}>
                                            {/*   {console.warn( sortedSuggestions)} */}
                                            {sortedSuggestions?.map(activity => {


                                                return (
                                                    <div key={activity.place_id || activity.id} className={styles.activityCard}>
                                                        <Link to={`/activity_details/${activity.place_id}`} className={styles.cardImageWrapper}>


                                                            <img
                                                                className={styles.cardImage}
                                                                src={activity.photos ? activity.photos[0]?.photo_reference ? `${API_URL}/place-photo?photoRef=${activity.photos[0].photo_reference}` : '' : '/no_img4.png'}

                                                                alt={activity.activityName}
                                                                onError={(e) => { console.error(e.target.src) }}
                                                                referrerPolicy="no-referrer" />



                                                            {/*               <img
                                                            className={styles.cardImage}

                                                            src={`${activity.images[0].url}`}
                                                            alt={activity.activityName}
                                                            onError={(e) => { console.error(e.target.src) }}
                                                            referrerPolicy="no-referrer" /> */}

                                                            <div className={styles.cardRating}>

                                                                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#FBBF24"><path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z" /></svg>
                                                                {/* <span>{activity.reviews.combinedAverageRating}</span> */}

                                                                <span>{activity.rating ? activity.rating : 'No Rating'}</span>
                                                            </div>
                                                        </Link>
                                                        <div className={styles.cardBody}>
                                                            <h3 className={styles.cardActivityTitle}>{activity.name}</h3>
                                                            <h3 className={styles.cardActivityTitle}>{activity.title}</h3>
                                                            {activity.editorial_summary?.overview && (
                                                                <p className={styles.cardDescription}>{activity.editorial_summary.overview}</p>
                                                            )}
                                                            <div className={styles.cardFooterDetails}>
                                                                <span className={styles.cardPrice}>{activity.price ? `$${activity.price}` : ''}</span>
                                                                <span className={styles.cardDuration}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#333333b3"><path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" /></svg>
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className={styles.cardActions}>
                                                            <Link to={`/activity_details/${activity.place_id}`} className={styles.viewDetailsButton}>View Details</Link>
                                                            <ItineraryButton 
                                                                activity={activity}
                                                                isInItinerary={isInItinerary}
                                                                addToItinerary={addToItinerary}
                                                                removeFromItinerary={removeFromItinerary}
                                                                onAdd={() => setShowItinerary(true)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        {sortedSuggestions?.length === 0 && (
                                            <div className={styles.noResults}>
                                                {/*   <p>No activities found{searchQuery ? ` for "${searchQuery}"` : ''}.</p> */}
                                                <p>Try removing filters or changing the search.</p>
                                            </div>
                                        )}

                                        {nextPageToken.value &&
                                            <div className={styles.loadMoreContainer}>
                                                <button className={styles.loadMoreButton} onClick={getMore}>{loadMoreActive ? "Loading..." : "Load More"}</button>
                                            </div>
                                        }

                                    </section>
                                    : <div>
                                        <p>{error.message}</p>
                                    </div>
                            }
                        </div>
                    </>

                }




            </main >

            {/* Itinerary Component */}
            <Itinerary 
                itinerary={itinerary}
                removeFromItinerary={removeFromItinerary}
                clearItinerary={clearItinerary}
                isOpen={showItinerary}
                setIsOpen={setShowItinerary}
            />

            {/* Map View Modal */}
            {showMapView && (
                <div className={styles.mapModalOverlay}>
                    <div className={styles.mapModalContent}>
                        <div className={styles.mapModalHeader}>
                            <h2 className={styles.mapModalTitle}>Activities Map</h2>
                            <button
                                className={styles.mapModalClose}
                                onClick={() => setShowMapView(false)}
                                aria-label="Close map"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
                                    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                                </svg>
                            </button>
                        </div>
                        <div className={styles.mapModalBody}>


                            {/* Activities List  (Left Side) */}
                            <div className={styles.mapActivitiesList}>
                                <div className={styles.mapActivitiesListHeader}>
                                    <h3 className={styles.mapActivitiesListTitle}>
                                        {sortedSuggestions?.filter(activity => activity.location?.lat && activity.location?.lng).length || 0} Activities
                                    </h3>
                                </div>
                                <div className={styles.mapActivitiesListContent}>
                                    {sortedSuggestions?.filter(activity => activity.location?.lat && activity.location?.lng).map((activity, index) => {
                                        const activityId = activity.place_id || index;
                                        const isHovered = hoveredActivityId === activityId;
                                        return (
                                            <Link to={`/activity_details/${activity.place_id}`}
                                                key={activityId}
                                                className={`${styles.mapActivityItem} ${isHovered ? styles.mapActivityItemHovered : ''}`}
                                                onMouseEnter={() => handleActivityHover(activityId, activity)}
                                                onMouseLeave={handleActivityHoverEnd}
                                            >
                                                <div className={styles.mapActivityItemContent}>
                                                    {
        
                                                        <img
                                                               src={activity.photos ? activity.photos[0]?.photo_reference ? `${API_URL}/place-photo?photoRef=${activity.photos[0].photo_reference}` : '' : '/no_img4.png'}
                                                            alt={activity.name || activity.title}
                                                            className={styles.mapActivityImage}
                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                        />
                                                    }
                                                    <div className={styles.mapActivityInfo}>
                                                        <h4 className={styles.mapActivityName}>{activity.name || activity.title}</h4>
                                                        {activity.rating && (
                                                            <div className={styles.mapActivityRating}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#FBBF24">
                                                                    <path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z" />
                                                                </svg>
                                                                <span>{activity.rating}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <a
                                                    href={`https://www.google.com/maps?q=${activity.location.lat},${activity.location.lng}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.mapActivityLink}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000">
                                                        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" />
                                                    </svg>
                                                </a>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                            {/* Map Container (Right Side)*/}
                            <div className={styles.mapContainer}>
                                {loadError && (
                                    <div className={styles.mapPlaceholder}>
                                        <p>Error loading map. Check your API key.</p>
                                    </div>
                                )}
                                {!isLoaded && !loadError && (
                                    <div className={styles.mapPlaceholder}>
                                        <p>Loading map...</p>
                                    </div>
                                )}
                                {isLoaded && !loadError && (
                                    <GoogleMap
                                        mapContainerStyle={mapContainerStyle}
                                        center={getMapCenter()}
                                        zoom={12}
                                        options={mapOptions}
                                        onLoad={onMapLoad}
                                    >
                                        {sortedSuggestions?.filter(activity => activity.location?.lat && activity.location?.lng).map((activity, index) => {
                                            const activityId = activity.place_id || index;
                                            const isHovered = hoveredActivityId === activityId;
                                            return (
                                                <MarkerF
                                                    key={activityId}
                                                    position={{ lat: activity.location.lat, lng: activity.location.lng }}
                                                    title={activity.name || activity.title}
                                                    animation={isHovered ? window.google.maps.Animation.BOUNCE : undefined}
                                                    zIndex={isHovered ? 1000 : undefined}
                                                />
                                            );
                                        })}
                                    </GoogleMap>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};